import { jsx as _jsx } from "react/jsx-runtime";
import { optimizeImageUrlFillRectangle } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import React from "react";
import { AspectRatioPicture } from "@faire/retailer/components/Image/AspectRatioPicture";
export var SingleImage = function(param) {
    var image = param.image, imageRatio = param.imageRatio, imageHeight = param.imageHeight;
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsx(AspectRatioPicture, {
        $ratio: imageRatio,
        $height: imageHeight,
        $hideBorder: true,
        children: /*#__PURE__*/ _jsx("img", {
            src: optimizeImageUrlFillRectangle(image, isSSR, imageRatio * imageHeight, imageHeight)
        })
    });
};
